import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { RgiRealEstateFormValues, UpiRealEstateFormValues } from '../types/realEstateFormValues';
import { addressFieldWithoutPlaceId, addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { RealEstateFormFieldNames } from '../types/realEstateFormFieldNames';

export const upiRealEstateValidationRules: ValidationRules<Exclude<keyof UpiRealEstateFormValues, 'id'>> = {
  [RealEstateFormFieldNames.Name]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères')
    .max(100, 'Le nom ne doit pas dépasser 100 caractères'),

  [RealEstateFormFieldNames.Area]: Yup.number()
    .required('Ce champ est requis')
    .positive('La superficie doit être positive')
    .min(1, 'La superficie minimum est de 1 m²')
    .max(10000, 'La superficie ne peut pas dépasser 10 000 m²')
    .typeError('La superficie doit être un nombre'),

  [RealEstateFormFieldNames.RoomCount]: Yup.number()
    .required('Ce champ est requis')
    .integer('Le nombre de pièces doit être un nombre entier')
    .min(1, 'Le nombre minimum de pièces est 1')
    .max(20, 'Le nombre maximum de pièces est 20')
    .typeError('Le nombre de pièces doit être un nombre'),

  [RealEstateFormFieldNames.MonthlyRent]: Yup.number()
    .nullable()
    .typeError('Le loyer mensuel doit être un nombre'),

  [RealEstateFormFieldNames.Charges]: Yup.number()
    .nullable()
    .typeError('Les charges doivent être un nombre'),

  [RealEstateFormFieldNames.Photo]: Yup.string()
    .trim()
    .nullable(),

  [RealEstateFormFieldNames.PropertyType]: Yup.number(),

  [RealEstateFormFieldNames.SurveyForm]: Yup.object()
    .required('Ce champ est requis'),

  ...addressValidationRules,
  // Bien immobilier : pas de personne -> place_id non exigé (cf. spec).
  [AddressFormFieldNames.Address]: addressFieldWithoutPlaceId
};

export const rgiRealEstateValidationRules: ValidationRules<Exclude<keyof RgiRealEstateFormValues, 'id'>> = {
  [RealEstateFormFieldNames.Name]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères')
    .max(100, 'Le nom ne doit pas dépasser 100 caractères'),

  [RealEstateFormFieldNames.Area]: Yup.number()
    .required('Ce champ est requis')
    .positive('La superficie doit être positive')
    .min(1, 'La superficie minimum est de 1 m²')
    .max(10000, 'La superficie ne peut pas dépasser 10 000 m²')
    .typeError('La superficie doit être un nombre'),

  [RealEstateFormFieldNames.RoomCount]: Yup.number()
    .required('Ce champ est requis')
    .integer('Le nombre de pièces doit être un nombre entier')
    .min(1, 'Le nombre minimum de pièces est 1')
    .max(20, 'Le nombre maximum de pièces est 20')
    .typeError('Le nombre de pièces doit être un nombre'),

  [RealEstateFormFieldNames.MonthlyRent]: Yup.number()
    .nullable()
    .typeError('Le loyer mensuel doit être un nombre'),

  [RealEstateFormFieldNames.Charges]: Yup.number()
    .nullable()
    .typeError('Les charges doivent être un nombre'),

  [RealEstateFormFieldNames.Photo]: Yup.string()
    .trim()
    .nullable(),

  [RealEstateFormFieldNames.PropertyType]: Yup.number(),

  [RealEstateFormFieldNames.RentalType]: Yup.number(),

  [RealEstateFormFieldNames.SurveyForm]: Yup.object(),

  ...addressValidationRules,
  // Bien immobilier : pas de personne -> place_id non exigé (cf. spec).
  [AddressFormFieldNames.Address]: addressFieldWithoutPlaceId
};
